const httpLib = require('./http-library.js');

exports.Cloudinary = {
  create: function createCloudinaryImage (fileName, callback) {
    const requestBody = {};
    requestBody.file = fileName;
    requestBody.upload_preset = 'e6m9x7iz';

    const requestParams = {
      path: 'https://api.cloudinary.com/v1_1/peerspace-inc/image/upload',
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      }
    };

    httpLib.request(requestParams, function (response) {
      const err = response.error;
      const successResponse = !err ? response : null;
      callback(err, successResponse);
    }, requestBody);
  }
};
